module.exports = __webpack_public_path__ + "static/media/Armor.53ea99e3.png";